import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  reverse2o3etdk6ug8y7 as reverse,
  copyOfq9pcgcgbldck as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isFloatArrayjjscnqphw92j as isFloatArray,
  createThis2j2avj17cvnv2 as createThis,
  takeg3iw3d2yd8b4 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf_0,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  until1jbpn0z3f8lbg as until,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toSet2orjxp16sotqu as toSet,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  indexOf3tp8bzbv46hci as indexOf,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.d2m() && y < this.e2m();
}
function getAt(x, y) {
  return this.l2m(x, y) ? this.sz(indexOr(this, x, y)) : this.sz(0);
}
function asString() {
  var tmp = until(0, this.e2m());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.g2m(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.h2m(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.g2m(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.a2m_1 = width;
    this.b2m_1 = height;
    this.c2m_1 = data;
    Companion_instance_4.f2m(this.d2m(), this.e2m(), this.c2m_1.length);
  }
  d2m() {
    return this.a2m_1;
  }
  e2m() {
    return this.b2m_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.d2m() === other.d2m();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.e2m() === other.e2m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.c2m_1, other.c2m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  g2m(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.c2m_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.c2m_1[0];
    }
    return tmp;
  }
  h2m(idx, value) {
    if (0 <= idx ? idx <= (this.c2m_1.length - 1 | 0) : false) {
      this.c2m_1[idx] = value;
    }
  }
  hashCode() {
    return (this.d2m() + this.e2m() | 0) + contentHashCode(this.c2m_1) | 0;
  }
  b1() {
    return intArrayIterator(this.c2m_1);
  }
  toString() {
    return this.i2m();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.g2m(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.p2m(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.g2m(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.m2m_1 = width;
    this.n2m_1 = height;
    this.o2m_1 = data;
    Companion_instance_4.f2m(this.d2m(), this.e2m(), this.o2m_1.length);
  }
  d2m() {
    return this.m2m_1;
  }
  e2m() {
    return this.n2m_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.d2m() === other.d2m();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.e2m() === other.e2m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.o2m_1, other.o2m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  g2m(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.o2m_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  p2m(idx, value) {
    if (0 <= idx ? idx <= (this.o2m_1.length - 1 | 0) : false) {
      this.o2m_1[idx] = value;
    }
  }
  hashCode() {
    return (this.d2m() + this.e2m() | 0) + contentHashCode_0(this.o2m_1) | 0;
  }
  b1() {
    return floatArrayIterator(this.o2m_1);
  }
  toString() {
    return this.i2m();
  }
}
class ByteArrayDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.z2m_1 = initialBits;
    this.a2n_1 = allowGrow;
    this.b2n_1 = new RingBuffer(this.z2m_1);
    this.c2n_1 = new Int8Array(1024);
    this.d2n_1 = new Long(0, 0);
    this.e2n_1 = new Long(0, 0);
  }
  w15() {
    return this.b2n_1.y2m_1;
  }
  x15(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.b2n_1.x15(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.d2n_1 = this.d2n_1.y3(toLong(out));
    }
    return out;
  }
  g2n(buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.x15(buffer, offset, size) : $super.x15.call(this, buffer, offset, size);
  }
  m16(count) {
    return this.b2n_1.m16(count);
  }
  l16(buffer, offset, size) {
    return this.b2n_1.l16(buffer, offset, size);
  }
  k3() {
    this.b2n_1.k3();
  }
  hashCode() {
    return this.b2n_1.z15();
  }
  equals(other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.b2n_1.equals(other.b2n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ShortArrayDeque {
  constructor(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.q2n_1 = initialBits;
    this.r2n_1 = new ShortRingBuffer(this.q2n_1);
    this.s2n_1 = new Int16Array(1024);
    this.t2n_1 = new Long(0, 0);
    this.u2n_1 = new Long(0, 0);
  }
  w15() {
    return this.r2n_1.o2n_1;
  }
  w2n(buffer, offset, size) {
    var out = ensureWrite_0(this, size).r2n_1.w2n(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.t2n_1 = this.t2n_1.y3(toLong(out));
    }
    return out;
  }
  v2n(buffer, offset, size) {
    var out = this.r2n_1.v2n(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.u2n_1 = this.u2n_1.y3(toLong(out));
    }
    return out;
  }
  k3() {
    this.r2n_1.k3();
  }
  x2n() {
    this.v2n(this.s2n_1, 0, 1);
    return this.s2n_1[0];
  }
  y2n(value) {
    this.s2n_1[0] = value;
    this.w2n(this.s2n_1, 0, 1);
  }
  hashCode() {
    return this.r2n_1.z15();
  }
  equals(other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.r2n_1.equals(other.r2n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Companion_1 {}
class FloatArrayList {
  static b2o(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.z2n_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.a2o_1 = 0;
    return $this;
  }
  qu(value) {
    ensure(this, value);
    this.a2o_1 = value;
  }
  f1() {
    return this.a2o_1;
  }
  static c2o(other) {
    var $this = this.b2o();
    $this.d2o(other);
    return $this;
  }
  k3() {
    this.a2o_1 = 0;
  }
  e2o(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.z2n_1;
    var _unary__edvuaz = this.a2o_1;
    this.a2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.z2n_1;
    var _unary__edvuaz_0 = this.a2o_1;
    this.a2o_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.z2n_1;
    var _unary__edvuaz_1 = this.a2o_1;
    this.a2o_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.z2n_1;
    var _unary__edvuaz_2 = this.a2o_1;
    this.a2o_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  f2o(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.g2o(isFloatArray(values) ? values : THROW_CCE(), offset, this.z2n_1, this.f1(), length);
    this.qu(this.f1() + length | 0);
  }
  d2o(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.f2o(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.f2o.call(this, values, offset, length);
    }
    return tmp;
  }
  sz(index) {
    return this.z2n_1[index];
  }
  b1() {
    return this.b3(0);
  }
  h2o(element) {
    var inductionVariable = 0;
    var last = this.a2o_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.z2n_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  x2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.h2o((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  i2o(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      if (!this.h2o(e))
        return false;
    }
    return true;
  }
  y2(elements) {
    return this.i2o(elements);
  }
  h1() {
    return this.f1() === 0;
  }
  j2o() {
    return copyOf(this.z2n_1, this.a2o_1);
  }
  b3(index) {
    return take(this.z2n_1, this.a2o_1).b3(index);
  }
  hashCode() {
    return contentHashCode_2(this.z2n_1, 0, this.f1());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.f1() === other.f1() && contentEquals_2(this.z2n_1, other.z2n_1, 0, this.f1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gc(2 + imul(5, this.f1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.bc(', ');
        }
        this_0.ch(this.sz(n));
      }
       while (inductionVariable < last);
    this_0.cc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class IntArrayList {
  static m2o(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.k2o_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.l2o_1 = 0;
    return $this;
  }
  qu(value) {
    this.n2o(value);
    this.l2o_1 = value;
  }
  f1() {
    return this.l2o_1;
  }
  static o2o(other) {
    var $this = this.m2o();
    $this.p2o(other);
    return $this;
  }
  static q2o(other) {
    var $this = this.m2o();
    $this.r2o(other);
    return $this;
  }
  n2o(count) {
    if ((this.l2o_1 + count | 0) > this.k2o_1.length) {
      var tmp = this;
      var tmp_0 = this.k2o_1;
      // Inline function 'kotlin.math.max' call
      var a = this.l2o_1 + count | 0;
      var b = imul(this.k2o_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.k2o_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  k3() {
    this.l2o_1 = 0;
  }
  s2o(v0) {
    this.n2o(1);
    var tmp = this.k2o_1;
    var _unary__edvuaz = this.l2o_1;
    this.l2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  t2o(value) {
    return this.s2o(value);
  }
  u2o(value) {
    return this.p2o(value);
  }
  v2o(values, offset, length) {
    this.n2o(length);
    var tmp = Memory_instance;
    tmp.w2o(isIntArray(values) ? values : THROW_CCE(), offset, this.k2o_1, this.f1(), length);
    this.qu(this.f1() + length | 0);
  }
  r2o(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.v2o(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.v2o.call(this, values, offset, length);
    }
    return tmp;
  }
  p2o(values) {
    return this.v2o(values.k2o_1, 0, values.f1());
  }
  e1(index) {
    return this.k2o_1[index];
  }
  sz(index) {
    return this.k2o_1[index];
  }
  x2o(index, value) {
    if (index >= this.l2o_1) {
      this.n2o(index + 1 | 0);
      this.l2o_1 = index + 1 | 0;
    }
    this.k2o_1[index] = value;
  }
  b1() {
    return this.b3(0);
  }
  hp(element) {
    var inductionVariable = 0;
    var last = this.l2o_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.k2o_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  x2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.hp((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  y2o(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      if (!this.hp(e))
        return false;
    }
    return true;
  }
  y2(elements) {
    return this.y2o(elements);
  }
  h1() {
    return this.f1() === 0;
  }
  l2c() {
    return !(this.f1() === 0);
  }
  qk() {
    var tmp;
    if (this.h1()) {
      throw IndexOutOfBoundsException.je();
    } else {
      tmp = this.k2o_1[0];
    }
    return tmp;
  }
  z2o() {
    var tmp;
    if (this.h1()) {
      throw IndexOutOfBoundsException.je();
    } else {
      tmp = this.k2o_1[this.l2o_1 - 1 | 0];
    }
    return tmp;
  }
  a2p(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.n2o(1);
    if (this.l2c()) {
      Memory_instance.w2o(this.k2o_1, index, this.k2o_1, index + 1 | 0, this.l2o_1 - index | 0);
    }
    this.k2o_1[index] = value;
    this.l2o_1 = this.l2o_1 + 1 | 0;
    return this;
  }
  b2p(indexA, indexB) {
    var l = this.sz(indexA);
    var r = this.sz(indexB);
    this.x2o(indexA, r);
    this.x2o(indexB, l);
  }
  p3(index) {
    return this.c2p(index, 1);
  }
  c2p(index, count) {
    if (index < 0 || index >= this.l2o_1 || (index + count | 0) > this.l2o_1)
      throw IndexOutOfBoundsException.je();
    var out = this.k2o_1[index];
    if (count > 0) {
      if (index < (this.l2o_1 - count | 0)) {
        Memory_instance.w2o(this.k2o_1, index + count | 0, this.k2o_1, index, (this.l2o_1 - index | 0) - count | 0);
      }
      this.l2o_1 = this.l2o_1 - count | 0;
    }
    return out;
  }
  d2p() {
    return copyOf_0(this.k2o_1, this.l2o_1);
  }
  b3(index) {
    return take_0(this.k2o_1, this.l2o_1).b3(index);
  }
  hashCode() {
    return contentHashCode_3(this.k2o_1, 0, this.f1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.f1() === other.f1() && contentEquals_3(this.k2o_1, other.k2o_1, 0, this.f1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gc(2 + imul(5, this.f1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.bc(', ');
        }
        this_0.ah(this.sz(n));
      }
       while (inductionVariable < last);
    this_0.cc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static g2p(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.e2p_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.f2p_1 = 0;
    return $this;
  }
  qu(value) {
    ensure_0(this, value);
    this.f2p_1 = value;
  }
  f1() {
    return this.f2p_1;
  }
  static h2p(other) {
    var $this = this.g2p();
    $this.i2p(other);
    return $this;
  }
  static j2p(other) {
    var $this = this.g2p();
    $this.k2p(other);
    return $this;
  }
  k3() {
    this.f2p_1 = 0;
  }
  t11(v0) {
    ensure_0(this, 1);
    var tmp = this.e2p_1;
    var _unary__edvuaz = this.f2p_1;
    this.f2p_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  l2p(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.e2p_1;
    var _unary__edvuaz = this.f2p_1;
    this.f2p_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.e2p_1;
    var _unary__edvuaz_0 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  m2p(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.e2p_1;
    var _unary__edvuaz = this.f2p_1;
    this.f2p_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.e2p_1;
    var _unary__edvuaz_0 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.e2p_1;
    var _unary__edvuaz_1 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.e2p_1;
    var _unary__edvuaz_2 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  n2p(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.e2p_1;
    var _unary__edvuaz = this.f2p_1;
    this.f2p_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.e2p_1;
    var _unary__edvuaz_0 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.e2p_1;
    var _unary__edvuaz_1 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.e2p_1;
    var _unary__edvuaz_2 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.e2p_1;
    var _unary__edvuaz_3 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.e2p_1;
    var _unary__edvuaz_4 = this.f2p_1;
    this.f2p_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  o2p(value) {
    return this.t11(value);
  }
  p2p(value) {
    return this.i2p(value);
  }
  q2p(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.r2p(isDoubleArray(values) ? values : THROW_CCE(), offset, this.e2p_1, this.f1(), length);
    this.qu(this.f1() + length | 0);
  }
  k2p(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.q2p(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.q2p.call(this, values, offset, length);
    }
    return tmp;
  }
  i2p(values) {
    return this.q2p(values.e2p_1, 0, values.f1());
  }
  e1(index) {
    return this.e2p_1[index];
  }
  sz(index) {
    return this.e2p_1[index];
  }
  s2p(index, value) {
    if (index >= this.f2p_1) {
      ensure_0(this, index + 1 | 0);
      this.f2p_1 = index + 1 | 0;
    }
    this.e2p_1[index] = value;
  }
  b1() {
    return this.b3(0);
  }
  vz(element) {
    var inductionVariable = 0;
    var last = this.f2p_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.e2p_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  x2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.vz((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  wz(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      if (!this.vz(e))
        return false;
    }
    return true;
  }
  y2(elements) {
    return this.wz(elements);
  }
  h1() {
    return this.f1() === 0;
  }
  b2p(indexA, indexB) {
    var l = this.sz(indexA);
    var r = this.sz(indexB);
    this.s2p(indexA, r);
    this.s2p(indexB, l);
  }
  p3(index) {
    return this.c2p(index, 1);
  }
  c2p(index, count) {
    if (index < 0 || index >= this.f2p_1 || (index + count | 0) > this.f2p_1)
      throw IndexOutOfBoundsException.je();
    var out = this.e2p_1[index];
    if (count > 0) {
      if (index < (this.f2p_1 - count | 0)) {
        Memory_instance.r2p(this.e2p_1, index + count | 0, this.e2p_1, index, (this.f2p_1 - index | 0) - count | 0);
      }
      this.f2p_1 = this.f2p_1 - count | 0;
    }
    return out;
  }
  tz() {
    return copyOf_1(this.e2p_1, this.f2p_1);
  }
  b3(index) {
    return take_1(this.e2p_1, this.f2p_1).b3(index);
  }
  c3(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.e2p_1;
    return asList(tmp$ret$1).c3(fromIndex, toIndex);
  }
  uz() {
    return DoubleArrayList.h2p(this);
  }
  hashCode() {
    return contentHashCode_4(this.e2p_1, 0, this.f1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.f1() === other.f1() && contentEquals_4(this.e2p_1, other.e2p_1, 0, this.f1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gc(2 + imul(5, this.f1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.bc(', ');
        }
        this_0.dh(this.sz(n));
      }
       while (inductionVariable < last);
    this_0.cc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  y2p(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.x2p(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  t2p(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.x2p(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  u2p(subject, l, r) {
    return compareTo(subject.sz(l), subject.sz(r));
  }
  v2p(subject, l, r) {
    return this.u2p(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  w2p(subject, indexL, indexR) {
    var l = subject.sz(indexL);
    var r = subject.sz(indexR);
    subject.s2p(indexR, l);
    subject.s2p(indexL, r);
  }
  x2p(subject, indexL, indexR) {
    return this.w2p(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.e2q_1 = $that;
    this.f2q_1 = this$0;
    this.d2q_1 = 0;
  }
  d1() {
    var _unary__edvuaz = this.d2q_1;
    this.d2q_1 = _unary__edvuaz + 1 | 0;
    return this.e2q_1.e1(_unary__edvuaz);
  }
  c1() {
    return this.d2q_1 < this.f2q_1.f1();
  }
  r6() {
    this.d2q_1 = this.d2q_1 - 1 | 0;
    this.f2q_1.p3(this.d2q_1);
  }
}
class TGenDeque {
  static g2q(initialCapacity) {
    var $this = createThis(this);
    $this.z2p_1 = 0;
    $this.a2q_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.b2q_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static h2q() {
    return this.g2q(16);
  }
  f1() {
    return this.a2q_1;
  }
  h1() {
    return this.f1() === 0;
  }
  i2q(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  j2q(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.f1();
    resizeIfRequiredFor(this, count);
    var base = this.z2p_1 + this.a2q_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.b2q_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.e1(n);
      }
       while (inductionVariable < count);
    this.a2q_1 = this.a2q_1 + count | 0;
    return true;
  }
  k2q(elements) {
    return this.j2q(toList(elements));
  }
  g1(elements) {
    return this.k2q(elements);
  }
  uk() {
    if (this.a2q_1 <= 0)
      throw IndexOutOfBoundsException.je();
    var out = this.l2q();
    nullify(this, this.z2p_1);
    this.z2p_1 = (this.z2p_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.a2q_1 = this.a2q_1 - 1 | 0;
    return out;
  }
  wk() {
    if (this.a2q_1 <= 0)
      throw IndexOutOfBoundsException.je();
    var out = this.m2q();
    nullify(this, internalIndex(this, this.f1() - 1 | 0));
    this.a2q_1 = this.a2q_1 - 1 | 0;
    return out;
  }
  p3(index) {
    if (index < 0 || index >= this.f1())
      throw IndexOutOfBoundsException.je();
    if (index === 0)
      return this.uk();
    if (index === (this.f1() - 1 | 0))
      return this.wk();
    var old = this.e1(index);
    if (index < (this.f1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.n2q(n, this.e1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.z2p_1 = umod(this.z2p_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.f1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.n2q(n_0, this.e1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.a2q_1 = this.a2q_1 - 1 | 0;
    return old;
  }
  o2q(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.i2q(element);
    return true;
  }
  h(element) {
    return this.o2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  p2q(element) {
    var index = this.q2q(element);
    if (index >= 0) {
      this.p3(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.p2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  l2q() {
    return this.b2q_1[this.z2p_1];
  }
  m2q() {
    return this.b2q_1[internalIndex(this, this.f1() - 1 | 0)];
  }
  n2q(index, value) {
    this.b2q_1[internalIndex(this, index)] = value;
  }
  e1(index) {
    return this.b2q_1[internalIndex(this, index)];
  }
  r2q(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.f1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.TGenDeque.contains.<anonymous>' call
          var it = element_0;
          if (equals(this.e1(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  x2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.r2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  q2q(element) {
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.e1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  s2q(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.e1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.h3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.l3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.b1();
      while (tmp0_iterator_0.c1()) {
        var element = tmp0_iterator_0.d1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  y2(elements) {
    return this.s2q(elements);
  }
  b1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.f1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.e1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.f1() === this.f1()))
      return false;
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.e1(n), other.e1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.ac(this.e1(n));
        if (!(n === (this.f1() - 1 | 0))) {
          sb.bc(', ');
        }
      }
       while (inductionVariable < last);
    sb.cc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.x2q_1 = $that;
    this.y2q_1 = this$0;
    this.w2q_1 = 0;
  }
  d1() {
    var _unary__edvuaz = this.w2q_1;
    this.w2q_1 = _unary__edvuaz + 1 | 0;
    return this.x2q_1.e1(_unary__edvuaz);
  }
  c1() {
    return this.w2q_1 < this.y2q_1.f1();
  }
  r6() {
    this.w2q_1 = this.w2q_1 - 1 | 0;
    this.y2q_1.p3(this.w2q_1);
  }
}
class IntDeque {
  static z2q(initialCapacity) {
    var $this = createThis(this);
    $this.t2q_1 = 0;
    $this.u2q_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.v2q_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static a2r() {
    return this.z2q(16);
  }
  f1() {
    return this.u2q_1;
  }
  h1() {
    return this.f1() === 0;
  }
  b2r(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  c2r(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.f1();
    resizeIfRequiredFor_0(this, count);
    var base = this.t2q_1 + this.u2q_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.v2q_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.e1(n);
      }
       while (inductionVariable < count);
    this.u2q_1 = this.u2q_1 + count | 0;
    return true;
  }
  d2r(elements) {
    return this.c2r(toList(elements));
  }
  g1(elements) {
    return this.d2r(elements);
  }
  uk() {
    if (this.u2q_1 <= 0)
      throw IndexOutOfBoundsException.je();
    var out = this.l2q();
    nullify_0(this, this.t2q_1);
    this.t2q_1 = (this.t2q_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.u2q_1 = this.u2q_1 - 1 | 0;
    return out;
  }
  wk() {
    if (this.u2q_1 <= 0)
      throw IndexOutOfBoundsException.je();
    var out = this.m2q();
    nullify_0(this, internalIndex_0(this, this.f1() - 1 | 0));
    this.u2q_1 = this.u2q_1 - 1 | 0;
    return out;
  }
  p3(index) {
    if (index < 0 || index >= this.f1())
      throw IndexOutOfBoundsException.je();
    if (index === 0)
      return this.uk();
    if (index === (this.f1() - 1 | 0))
      return this.wk();
    var old = this.e1(index);
    if (index < (this.f1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.x2o(n, this.e1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.t2q_1 = umod(this.t2q_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.f1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.x2o(n_0, this.e1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.u2q_1 = this.u2q_1 - 1 | 0;
    return old;
  }
  e2r(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.b2r(element);
    return true;
  }
  h(element) {
    return this.e2r((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  f2r(element) {
    var index = this.g2r(element);
    if (index >= 0) {
      this.p3(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.f2r((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  l2q() {
    return this.v2q_1[this.t2q_1];
  }
  m2q() {
    return this.v2q_1[internalIndex_0(this, this.f1() - 1 | 0)];
  }
  x2o(index, value) {
    this.v2q_1[internalIndex_0(this, index)] = value;
  }
  e1(index) {
    return this.v2q_1[internalIndex_0(this, index)];
  }
  hp(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.f1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.IntDeque.contains.<anonymous>' call
          var it = element_0;
          if (this.e1(it) === element) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  x2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.hp((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  g2r(element) {
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.e1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  y2o(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.e1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.h3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.l3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.b1();
      while (tmp0_iterator_0.c1()) {
        var element = tmp0_iterator_0.d1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  y2(elements) {
    return this.y2o(elements);
  }
  b1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.f1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.e1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.f1() === this.f1()))
      return false;
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.e1(n) === other.e1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.ah(this.e1(n));
        if (!(n === (this.f1() - 1 | 0))) {
          sb.bc(', ');
        }
      }
       while (inductionVariable < last);
    sb.cc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static l2r() {
    var $this = this.c8();
    $this.h2r_1 = LinkedHashSet.i1();
    $this.i2r_1 = null;
    $this.j2r_1 = null;
    $this.k2r_1 = null;
    return $this;
  }
  f1() {
    return this.h2r_1.f1();
  }
  b1() {
    return this.h2r_1.b1();
  }
  m2r(element) {
    if (this.el(element))
      return false;
    this.h2r_1.h(element);
    return true;
  }
  h(element) {
    return this.m2r((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  n2r(element) {
    this.i2r_1 = null;
    this.j2r_1 = null;
    this.k2r_1 = null;
    this.h2r_1.m3(element);
    return true;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.n2r((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  el(element) {
    if (element === this.i2r_1 || element === this.j2r_1 || element === this.i2r_1)
      return true;
    var result = this.h2r_1.x2(element);
    if (result) {
      this.j2r_1 = this.i2r_1;
      this.k2r_1 = this.j2r_1;
      this.i2r_1 = element;
    }
    return result;
  }
  x2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.el((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  k3() {
    this.h2r_1.k3();
    this.i2r_1 = null;
    this.j2r_1 = null;
    this.k2r_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.o2r_1 = base;
    this.p2r_1 = start;
    this.q2r_1 = end;
    var containsUpper = this.o2r_1.f1();
    var containsArg = this.p2r_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.o1('' + this.p2r_1);
    var containsUpper_0 = this.o2r_1.f1();
    var containsArg_0 = this.q2r_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.o1('' + this.q2r_1);
  }
  f1() {
    return this.q2r_1 - this.p2r_1 | 0;
  }
  el(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.f1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.GenericSubList.contains.<anonymous>' call
          var it = element_0;
          if (equals(this.e1(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  x2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.el((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  fl(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.e1(n);
        elementsSet.m3(element);
      }
       while (inductionVariable < last);
    return elementsSet.h1();
  }
  y2(elements) {
    return this.fl(elements);
  }
  e1(index) {
    return this.o2r_1.e1(translateIndex(index, this));
  }
  r2r(element) {
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.e1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.r2r((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h1() {
    return this.f1() === 0;
  }
  b1() {
    return new GenericListIterator(this);
  }
  a3() {
    return new GenericListIterator(this);
  }
  b3(index) {
    return new GenericListIterator(this, index);
  }
  c3(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.f1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.e1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.f1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.e1(n), other.e1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.f1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.e1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.s2r_1 = list;
    this.t2r_1 = iindex;
    var containsUpper = this.s2r_1.f1();
    var containsArg = this.t2r_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.o1('' + this.t2r_1);
    this.u2r_1 = this.t2r_1;
  }
  c1() {
    return this.u2r_1 < this.s2r_1.f1();
  }
  d1() {
    if (!this.c1())
      throw NoSuchElementException.v6();
    var _unary__edvuaz = this.u2r_1;
    this.u2r_1 = _unary__edvuaz + 1 | 0;
    return this.s2r_1.e1(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.s2r_1, other.s2r_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u2r_1 === other.u2r_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s2r_1) + this.u2r_1 | 0;
  }
}
class Companion_4 {
  f2m(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.h5(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.l2s_1 = 2147483646;
    this.m2s_1 = 2147483647;
    this.n2s_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.r2s_1 = key;
    this.s2s_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.r2s_1 + ', value=' + toString_0(this.s2s_1) + ')';
  }
  hashCode() {
    var result = this.r2s_1;
    result = imul(result, 31) + (this.s2s_1 == null ? 0 : hashCode(this.s2s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.r2s_1 === tmp0_other_with_cast.r2s_1))
      return false;
    if (!equals(this.s2s_1, tmp0_other_with_cast.s2s_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.v2r_1 = map;
    this.w2r_1 = this.v2r_1.b2s_1 ? 2147483647 : nextNonEmptyIndex(this, this.v2r_1.f2s_1, 0);
    this.x2r_1 = new Entry(0, null);
  }
  c1() {
    return !(this.w2r_1 === 2147483646);
  }
  j2s() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  k2s() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.t2s_1 = this$0;
  }
  b1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.t2s_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.u2s_1 = this$0;
  }
  b1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.u2s_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static o2s(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.y2r_1 = nbits;
    $this.z2r_1 = loadFactor;
    $this.a2s_1 = 1 << $this.y2r_1;
    $this.b2s_1 = false;
    $this.c2s_1 = null;
    $this.d2s_1 = $this.a2s_1 - 1 | 0;
    $this.e2s_1 = 1 + imul($this.y2r_1, $this.y2r_1) | 0;
    $this.f2s_1 = new Int32Array($this.q2s());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.q2s();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.g2s_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.h2s_1 = numberToInt($this.a2s_1 * $this.z2r_1);
    $this.i2s_1 = 0;
    return $this;
  }
  static v2s(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.o2s(tmp$ret$0, loadFactor, true);
  }
  q2s() {
    return this.a2s_1 + this.e2s_1 | 0;
  }
  e1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.c2s_1;
    return this.g2s_1[index];
  }
  p2s(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.b2s_1 = true;
          this.c2s_1 = value;
          this.i2s_1 = this.i2s_1 + 1 | 0;
          return null;
        }
        if (this.i2s_1 >= this.h2s_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.f2s_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.f2s_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.f2s_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.f2s_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.f2s_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.e2s_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.c2s_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.c2s_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.g2s_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.g2s_1[index] = value;
        return this_1;
      }
    }
  }
  g3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  l3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  w2s(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.b2s_1 ? 2147483647 : this.w2s(this.f2s_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.f2s_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.e1(it);
      if (!equals(other.e1(key), value))
        return false;
      index = this.w2s(this.f2s_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.b2s_1 ? 2147483647 : this.w2s(this.f2s_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.f2s_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.e1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.w2s(this.f2s_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.x2s_1 = 2147483646;
    this.y2s_1 = 2147483647;
    this.z2s_1 = 0;
  }
}
class IntIntMap {
  static l2t(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.a2t_1 = nbits;
    $this.b2t_1 = loadFactor;
    $this.c2t_1 = 1 << $this.a2t_1;
    $this.d2t_1 = false;
    $this.e2t_1 = 0;
    $this.f2t_1 = $this.c2t_1 - 1 | 0;
    $this.g2t_1 = 1 + imul($this.a2t_1, $this.a2t_1) | 0;
    $this.h2t_1 = new Int32Array($this.q2s());
    $this.i2t_1 = new Int32Array($this.q2s());
    $this.j2t_1 = numberToInt($this.c2t_1 * $this.b2t_1);
    $this.k2t_1 = 0;
    return $this;
  }
  static n2t(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.l2t(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.o2t());
  }
  q2s() {
    return this.c2t_1 + this.g2t_1 | 0;
  }
  p2t(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2t_1 ? 2147483647 : this.w2s(this.h2t_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2t_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.e1(it);
      out.h3(key, value);
      index = this.w2s(this.h2t_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  o2t(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.p2t(out) : $super.p2t.call(this, out);
  }
  hp(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  k3() {
    this.d2t_1 = false;
    this.e2t_1 = 0;
    fill(this.h2t_1, 0);
    fill(this.i2t_1, 0);
    this.k2t_1 = 0;
  }
  e1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.e2t_1;
    return this.i2t_1[index];
  }
  m2t(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.d2t_1 = true;
          this.e2t_1 = value;
          this.k2t_1 = this.k2t_1 + 1 | 0;
          return 0;
        }
        if (this.k2t_1 >= this.j2t_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.h2t_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.h2t_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.h2t_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.h2t_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.h2t_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.g2t_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.e2t_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.e2t_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.i2t_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.i2t_1[index] = value;
        return this_1;
      }
    }
  }
  w2s(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2t_1 ? 2147483647 : this.w2s(this.h2t_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2t_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.e1(it);
      if (!(other.e1(key) === value))
        return false;
      index = this.w2s(this.h2t_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.d2t_1 ? 2147483647 : this.w2s(this.h2t_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h2t_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.e1(it) | 0) | 0;
      index = this.w2s(this.h2t_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.q2t_1 = $hasNext;
    this.r2t_1 = $next;
  }
  c1() {
    return this.q2t_1();
  }
  d1() {
    return this.r2t_1();
  }
}
class Companion_7 {}
class Pool {
  static w2t(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.s2t_1 = reset;
    $this.t2t_1 = gen;
    $this.u2t_1 = _TGenStack___init__impl__yynjgt();
    $this.v2t_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.v2t_1;
        $this.v2t_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.u2t_1, $this.t2t_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static x2t(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.w2t(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  y2t() {
    return _TGenStack___get_size__impl__cvg66t(this.u2t_1);
  }
  z2t() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.u2t_1)).h1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.u2t_1);
    } else {
      var _unary__edvuaz = this.v2t_1;
      this.v2t_1 = _unary__edvuaz + 1 | 0;
      tmp = this.t2t_1(_unary__edvuaz);
    }
    return tmp;
  }
  k3() {
    TGenStack__clear_impl_pali4s(this.u2t_1);
    this.v2t_1 = 0;
  }
  a2u(element) {
    this.s2t_1(element);
    TGenStack__push_impl_9yh33t(this.u2t_1, element);
  }
  b2u(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      this.a2u(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.u2t_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.u2t_1, other.u2t_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y2t() === other.y2t();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static j2u(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.w2t(reset, preallocate, gen);
    $this.g2u_1 = reset;
    $this.h2u_1 = gen;
    $this.i2u_1 = new NonRecursiveLock();
    return $this;
  }
  z2t() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.i2u_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.z2t();
  }
  k3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.i2u_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.k3();
  }
  a2u(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.i2u_1.d1y_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.a2u(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.k2u_1 = _reset;
    this.l2u_1 = gen;
    this.m2u_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.n2u_1 = Pool.w2t(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.o2u_1 = this.n2u_1.z2t();
  }
  d1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.m2u_1;
    var element = this.o2u_1;
    this_0.h(element);
    this.o2u_1 = this.n2u_1.z2t();
    return this.o2u_1;
  }
  p2u() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.m2u_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.n2u_1.a2u(it);
    }
    this.m2u_1.k3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.q2u_1 = function_0;
  }
  aj(a, b) {
    return this.q2u_1(a, b);
  }
  compare(a, b) {
    return this.aj(a, b);
  }
  o4() {
    return this.q2u_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class Companion_8 {
  r2u(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  s2u(reversed, comparator) {
    return Companion_instance_8.r2u(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  t2u(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.s2u(reversed, comparator) : $super.s2u.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.x2u_1 = $index;
    this.y2u_1 = this$0;
  }
  c1() {
    return this.x2u_1._v < this.y2u_1.w2u_1;
  }
  d1() {
    var _unary__edvuaz = this.x2u_1._v;
    this.x2u_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.y2u_1);
  }
  h1d() {
    throw NotImplementedError.be();
  }
  r6() {
    return this.h1d();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.u2u_1 = data;
    this.v2u_1 = comparator;
    this.w2u_1 = 0;
  }
  f1() {
    return this.w2u_1;
  }
  z2u() {
    if (this.w2u_1 <= 0)
      throw IndexOutOfBoundsException.je();
    return this.u2u_1[0];
  }
  o2q(element) {
    this.w2u_1 = this.w2u_1 + 1 | 0;
    ensure_1(this, this.w2u_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.w2u_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.o2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  a2v() {
    if (this.w2u_1 <= 0)
      throw IndexOutOfBoundsException.je();
    if (this.w2u_1 === 1) {
      this.w2u_1 = this.w2u_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.w2u_1 - 1 | 0), this));
    this.w2u_1 = this.w2u_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  q2q(element) {
    var inductionVariable = 0;
    var last = this.w2u_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.u2u_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  p2q(element) {
    var index = this.q2q(element);
    if (index >= 0) {
      this.b2v(index);
    }
    return index >= 0;
  }
  m3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.p2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  b2v(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.a2v();
  }
  r2q(element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = until(0, this.w2u_1);
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.TGenPriorityQueue.contains.<anonymous>' call
          var it = element_0;
          if (equals(_get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(it), this), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  x2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.r2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  s2q(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.x2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  y2(elements) {
    return this.s2q(elements);
  }
  h1() {
    return this.w2u_1 === 0;
  }
  k2q(elements) {
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var e = _iterator__ex2g4s.d1();
      this.o2q(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.h1();
  }
  g1(elements) {
    return this.k2q(elements);
  }
  b1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.u2u_1, other.u2u_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.v2u_1, other.v2u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.u2u_1);
  }
}
class TGenQueue {
  constructor() {
    this.c2v_1 = TGenDeque.h2q();
  }
  f1() {
    return this.c2v_1.f1();
  }
  h1() {
    return this.f1() === 0;
  }
  d2v(v) {
    this.c2v_1.i2q(v);
  }
  e2v() {
    return this.c2v_1.uk();
  }
  r2q(element) {
    return this.c2v_1.r2q(element);
  }
  x2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.r2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  s2q(elements) {
    return this.c2v_1.s2q(elements);
  }
  y2(elements) {
    return this.s2q(elements);
  }
  b1() {
    return this.c2v_1.b1();
  }
  hashCode() {
    return this.c2v_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.c2v_1.equals(other.c2v_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  f2v(_set____db54di) {
    this.g2v_1 = _set____db54di;
  }
  s1() {
    var tmp = this.g2v_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.h2v_1 = $prop;
  }
  f2v(value) {
    this.h2v_1.set(value);
  }
  s1() {
    return this.h2v_1.get();
  }
}
class ByteRingBuffer {
  constructor(bits) {
    this.r2m_1 = bits;
    this.s2m_1 = 1 << this.r2m_1;
    this.t2m_1 = this.s2m_1 - 1 | 0;
    this.u2m_1 = new Int8Array(this.s2m_1);
    this.v2m_1 = 0;
    this.w2m_1 = 0;
    this.x2m_1 = this.s2m_1;
    this.y2m_1 = 0;
  }
  e16() {
    return this.u2m_1;
  }
  f16() {
    return this.v2m_1 & this.t2m_1;
  }
  g16() {
    return this.w2m_1 & this.t2m_1;
  }
  h16(count) {
    if (count < 0 || count > this.x2m_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.h5(toString(message));
    }
    this.w2m_1 = this.w2m_1 + count | 0;
    this.y2m_1 = this.y2m_1 + count | 0;
    this.x2m_1 = this.x2m_1 - count | 0;
  }
  i16(count) {
    if (count < 0 || count > this.y2m_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.h5(toString(message));
    }
    this.v2m_1 = this.v2m_1 + count | 0;
    this.y2m_1 = this.y2m_1 - count | 0;
    this.x2m_1 = this.x2m_1 + count | 0;
  }
  j16() {
    // Inline function 'kotlin.math.min' call
    var a = this.y2m_1;
    var b = this.s2m_1 - (this.v2m_1 & this.t2m_1) | 0;
    return Math.min(a, b);
  }
  k16() {
    // Inline function 'kotlin.math.min' call
    var a = this.x2m_1;
    var b = this.s2m_1 - (this.w2m_1 & this.t2m_1) | 0;
    return Math.min(a, b);
  }
  f2n(consume) {
    while (consume.y2m_1 > 0) {
      // Inline function 'kotlin.math.min' call
      var a = consume.j16();
      var b = this.k16();
      var copySize = Math.min(a, b);
      Memory_instance.i2v(consume.e16(), consume.f16(), this.e16(), this.g16(), copySize);
      consume.i16(copySize);
      this.h16(copySize);
    }
  }
  x15(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.x2m_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.math.min' call
      var a_0 = remaining;
      var b = this.k16();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      Memory_instance.i2v(data, coffset, this.u2m_1, this.g16(), chunkSize);
      this.h16(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  m16(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.y2m_1;
    var toRead = Math.min(a, size);
    this.v2m_1 = (this.v2m_1 + toRead | 0) & this.t2m_1;
    this.x2m_1 = this.x2m_1 + toRead | 0;
    this.y2m_1 = this.y2m_1 - toRead | 0;
    return toRead;
  }
  l16(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.y2m_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.u2m_1;
    var mask = this.t2m_1;
    var coffset = offset;
    var lReadPos = this.v2m_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.j16();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.i2v(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  k3() {
    this.v2m_1 = 0;
    this.w2m_1 = 0;
    this.y2m_1 = 0;
    this.x2m_1 = this.s2m_1;
  }
  o16(offset) {
    return this.u2m_1[(this.v2m_1 + offset | 0) & this.t2m_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.y2m_1 === other.y2m_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.y2m_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            if (!(this.o16(n) === other.o16(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.z15();
  }
  z15() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.y2m_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.o16(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class RingBuffer extends ByteRingBuffer {}
class ShortRingBuffer {
  constructor(bits) {
    this.h2n_1 = bits;
    this.i2n_1 = 1 << this.h2n_1;
    this.j2n_1 = this.i2n_1 - 1 | 0;
    this.k2n_1 = new Int16Array(this.i2n_1);
    this.l2n_1 = 0;
    this.m2n_1 = 0;
    this.n2n_1 = this.i2n_1;
    this.o2n_1 = 0;
    this.p2n_1 = new Int16Array(1);
  }
  w2n(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.n2n_1;
    var toWrite = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.k2n_1[this.m2n_1] = data[offset + n | 0];
        this.m2n_1 = (this.m2n_1 + 1 | 0) & this.j2n_1;
      }
       while (inductionVariable < toWrite);
    this.o2n_1 = this.o2n_1 + toWrite | 0;
    this.n2n_1 = this.n2n_1 - toWrite | 0;
    return toWrite;
  }
  v2n(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.o2n_1;
    var toRead = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.k2n_1[this.l2n_1];
        this.l2n_1 = (this.l2n_1 + 1 | 0) & this.j2n_1;
      }
       while (inductionVariable < toRead);
    this.n2n_1 = this.n2n_1 + toRead | 0;
    this.o2n_1 = this.o2n_1 - toRead | 0;
    return toRead;
  }
  k3() {
    this.l2n_1 = 0;
    this.m2n_1 = 0;
    this.o2n_1 = 0;
    this.n2n_1 = this.i2n_1;
  }
  o16(offset) {
    return this.k2n_1[(this.l2n_1 + offset | 0) & this.j2n_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.o2n_1 === other.o2n_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.o2n_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ShortRingBuffer.equals.<anonymous>' call
            if (!(this.o16(n) === other.o16(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.z15();
  }
  z15() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.o2n_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ShortRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.o16(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.j2v_1 = items;
  }
  f1() {
    return _TGenStack___get_size__impl__cvg66t(this.j2v_1);
  }
  h1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.j2v_1);
  }
  r2q(element) {
    return TGenStack__contains_impl_l8kli6(this.j2v_1, element);
  }
  x2(element) {
    return TGenStack__contains_impl_l8kli6_0(this, element);
  }
  s2q(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.j2v_1, elements);
  }
  y2(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  b1() {
    return TGenStack__iterator_impl_2pdia5(this.j2v_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.j2v_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.j2v_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.j2v_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.k2v_1 = new Lock();
    this.l2v_1 = false;
  }
  m2v(value) {
    if (!(this.l2v_1 === value)) {
      this.l2v_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.k2v_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.i1y();
        try {
          this.k2v_1.m1y();
          break $l$block;
        }finally {
          this_0.k1y();
        }
      }
    }
  }
}
class Memory {
  c2q(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  i2v(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  w2o(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  g2o(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  r2p(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.f1() === 0;
}
function getX(index) {
  return this.m2c(index, 0);
}
function getY(index) {
  return this.m2c(index, 1);
}
function get_1(index) {
  return Vector2D.k2c(this.m2c(index, 0), this.m2c(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.f1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.m2c(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.f1()) : out;
  return $super === VOID ? this.n2v(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.e1(0);
}
function get_last() {
  return this.e1(this.f1() - 1 | 0);
}
function contains(p) {
  return this.j2i(p.a2a_1, p.b2a_1);
}
function contains_0(x, y) {
  var inductionVariable = 0;
  var last = this.f1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (this.h2c(n) === x && this.i2c(n) === y)
        return true;
    }
     while (inductionVariable < last);
  return false;
}
function clone(out) {
  out.t2v(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.f1()) : out;
  return $super === VOID ? this.p2v(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.q2v_1 = new Mixin();
    this.r2v_1 = false;
    this.s2v_1 = DoubleArrayList.g2p(imul(capacity, 2));
  }
  yz(_set____db54di) {
    this.q2v_1.yz(_set____db54di);
  }
  zz() {
    return this.q2v_1.zz();
  }
  f1() {
    return this.s2v_1.f1() / 2 | 0;
  }
  m2c(index_0, dim) {
    return this.s2v_1.sz(index(this, index_0, dim));
  }
  h2c(index_0) {
    return this.s2v_1.sz(index(this, index_0, 0));
  }
  i2c(index_0) {
    return this.s2v_1.sz(index(this, index_0, 1));
  }
  e1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.k2c(this.s2v_1.sz(i), this.s2v_1.sz(i + 1 | 0));
  }
  hh() {
    this.s2v_1.k3();
    return this;
  }
  v2v(x, y) {
    this.s2v_1.l2p(x, y);
    return this;
  }
  w2v(p) {
    return this.v2v(p.a2a_1, p.b2a_1);
  }
  x2v(p) {
    return this.y2v(p);
  }
  y2v(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.f1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.e1(_unary__edvuaz);
      var x = destruct.nl();
      var y = destruct.ol();
      this.v2v(x, y);
    }
    return this;
  }
  z2v(p, index) {
    this.v2v(p.h2c(index), p.i2c(index));
  }
  t2v(other) {
    this.hh();
    this.x2v(other);
    return this;
  }
  p2v(out) {
    return out.hh().x2v(this);
  }
  c2p(index_0, count) {
    this.s2v_1.c2p(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  a2w(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.c2p(index, count) : $super.c2p.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.s2v_1.equals(other.s2v_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.s2v_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.e1(n);
        var x = _destruct__k2r9zo.nl();
        var y = _destruct__k2r9zo.ol();
        if (!(n === 0)) {
          sb.bc(', ');
        }
        sb.cc(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.ah(numberToInt(x));
        else
          sb.dh(x);
        sb.bc(', ');
        if (y === round(y))
          sb.ah(numberToInt(y));
        else
          sb.dh(y);
        sb.cc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.cc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  x2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.g2c(element instanceof Vector2D ? element : THROW_CCE());
  }
  cz(other, epsilon) {
    return this.n2c((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  y2(elements) {
    return this.e2c(elements);
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.c2c(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.b2w_1 = new Mixin();
    this.c2w_1 = dimensions;
    this.d2w_1 = DoubleArrayList.g2p(imul(capacity, this.c2w_1));
    this.e2w_1 = false;
  }
  yz(_set____db54di) {
    this.b2w_1.yz(_set____db54di);
  }
  zz() {
    return this.b2w_1.zz();
  }
  o2c() {
    return this.c2w_1;
  }
  f1() {
    return this.d2w_1.f1() / this.c2w_1 | 0;
  }
  m2c(index, dim) {
    return this.d2w_1.e1(imul(index, this.c2w_1) + dim | 0);
  }
  l2p(v0, v1) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.d2w_1.l2p(v0, v1);
    return Unit_instance;
  }
  m2p(v0, v1, v2, v3) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.d2w_1.m2p(v0, v1, v2, v3);
    return Unit_instance;
  }
  n2p(v0, v1, v2, v3, v4, v5) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.d2w_1.n2p(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  f2w(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.c2w_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.c2w_1 === other.c2w_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.d2w_1.equals(other.d2w_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.d2w_1.hashCode();
  }
  toString() {
    return this.g2w(null);
  }
  g2w(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.toString.<anonymous>' call
    this_0.bc('VectorArrayList[' + this.f1() + '](\n');
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.bc(', \n');
        }
        this_0.bc('   ');
        this.f2w(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.bc('\n)');
    return this_0.toString();
  }
  k3() {
    this.d2w_1.k3();
  }
  cz(other, epsilon) {
    return this.n2c((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.h2w_1 = new Mixin();
    this.i2w_1 = false;
    this.j2w_1 = IntArrayList.m2o(capacity);
    this.k2w_1 = IntArrayList.m2o(capacity);
  }
  yz(_set____db54di) {
    this.h2w_1.yz(_set____db54di);
  }
  zz() {
    return this.h2w_1.zz();
  }
  f1() {
    return this.j2w_1.f1();
  }
  h1() {
    return this.f1() === 0;
  }
  k3() {
    this.j2w_1.k3();
    this.k2w_1.k3();
  }
  l2w(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.j2w_1.t2o(x);
    this.k2w_1.t2o(y);
    return this;
  }
  m2w(p) {
    return this.l2w(p.g2j_1, p.h2j_1);
  }
  h2c(index) {
    return this.j2w_1.sz(index);
  }
  i2c(index) {
    return this.k2w_1.sz(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.cc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.h2c(n);
        var y = this.i2c(n);
        if (!(n === 0)) {
          sb.bc(', ');
        }
        sb.cc(_Char___init__impl__6a9atx(40));
        sb.ah(x);
        sb.bc(', ');
        sb.ah(y);
        sb.cc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.cc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function ensureWrite($this, count) {
  if (count <= $this.b2n_1.x2m_1)
    return Unit_instance;
  if (!$this.a2n_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.b2n_1.x2m_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.h5(toString(message));
  }
  var minNewSize = $this.b2n_1.y2m_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new RingBuffer(ilog2(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.ByteArrayDeque.ensureWrite.<anonymous>' call
  this_0.f2n($this.b2n_1);
  tmp.b2n_1 = this_0;
}
function ensureWrite_0($this, count) {
  if (count > $this.r2n_1.n2n_1) {
    var minNewSize = $this.r2n_1.o2n_1 + count | 0;
    var newBits = ilog2(minNewSize) + 2 | 0;
    var newRing = new ShortRingBuffer(newBits);
    while ($this.r2n_1.o2n_1 > 0) {
      var read = $this.r2n_1.v2n($this.s2n_1, 0, $this.s2n_1.length);
      newRing.w2n($this.s2n_1, 0, read);
    }
    $this.r2n_1 = newRing;
  }
  return $this;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function ensure($this, count) {
  if (($this.a2o_1 + count | 0) > $this.z2n_1.length) {
    var tmp = $this;
    var tmp_0 = $this.z2n_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.a2o_1 + count | 0;
    var b = imul($this.z2n_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.z2n_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.f2p_1 + count | 0) > $this.e2p_1.length) {
    var tmp = $this;
    var tmp_0 = $this.e2p_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.f2p_1 + count | 0;
    var b = imul($this.e2p_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.e2p_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.q2o(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.q2o(_this__u8e3s4.slice());
}
function floatArrayListOf(values) {
  return FloatArrayList.c2o(values.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.j2p(values.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.f1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.f1() : end;
  return DoubleArrayListSortOps_getInstance().t2p(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.b2q_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.b2q_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.f1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.b2q_1;
    var istart = $this.z2p_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.b2q_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.f1() + count | 0;
    var b = imul($this.b2q_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.a2q_1);
    $this.b2q_1 = o;
    $this.z2p_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.c2q(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.c2q(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.b2q_1[($this.z2p_1 + $this.a2q_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.a2q_1 = $this.a2q_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.z2p_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.v2q_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.v2q_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.f1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.v2q_1;
    var istart = $this.t2q_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.v2q_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.f1() + count | 0;
    var b = imul($this.v2q_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.u2q_1);
    $this.v2q_1 = o;
    $this.t2q_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.w2o(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.w2o(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.v2q_1[($this.t2q_1 + $this.u2q_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.u2q_1 = $this.u2q_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.t2q_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.f1() : false))
    throw IndexOutOfBoundsException.o1('' + _this__u8e3s4);
  return $this.p2r_1 + _this__u8e3s4 | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.d2m());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.k2m(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.d2m() : false) || !(0 <= y ? y < _this__u8e3s4.e2m() : false))
    return invalid;
  return imul(y, _this__u8e3s4.d2m()) + x | 0;
}
function currentKey($this) {
  switch ($this.w2r_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.v2r_1.f2s_1[$this.w2r_1];
  }
}
function currentValue($this) {
  switch ($this.w2r_1) {
    case 2147483647:
      return $this.v2r_1.c2s_1;
    case 2147483646:
      return null;
    default:
      return $this.v2r_1.g2s_1[$this.w2r_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.w2r_1 === 2147483646))
    $this.w2r_1 = nextNonEmptyIndex($this, $this.v2r_1.f2s_1, $this.w2r_1 === 2147483647 ? 0 : $this.w2r_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.c1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.j2s();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.c1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.k2s();
  };
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.f2s_1.length - $this.e2s_1 | 0;
}
function grow($this) {
  var inc = $this.y2r_1 < 20 ? 3 : 1;
  var newnbits = $this.y2r_1 + inc | 0;
  var new_0 = IntMap.o2s(newnbits, $this.z2r_1, true);
  var inductionVariable = 0;
  var last = $this.f2s_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.f2s_1[n];
      if (!(k === 0)) {
        new_0.p2s(k, $this.g2s_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.y2r_1 = new_0.y2r_1;
  $this.a2s_1 = new_0.a2s_1;
  $this.d2s_1 = new_0.d2s_1;
  $this.e2s_1 = new_0.e2s_1;
  $this.f2s_1 = new_0.f2s_1;
  $this.g2s_1 = new_0.g2s_1;
  $this.h2s_1 = new_0.h2s_1;
}
function growStash($this) {
  $this.e2s_1 = imul($this.e2s_1, 2);
  $this.f2s_1 = copyOf_0($this.f2s_1, $this.q2s());
  $this.g2s_1 = copyOf_2($this.g2s_1, $this.q2s());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.b2s_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.f2s_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.f2s_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.f2s_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.f2s_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.f2s_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.f2s_1[index] === 0))
    throw IllegalStateException.y5();
  $this.f2s_1[index] = key;
  $this.g2s_1[index] = value;
  $this.i2s_1 = $this.i2s_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.d2s_1);
}
function hash2($this, key) {
  return _hash2(key, $this.d2s_1);
}
function hash3($this, key) {
  return _hash3(key, $this.d2s_1);
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.h2t_1.length - $this.g2t_1 | 0;
}
function grow_0($this) {
  var inc = $this.a2t_1 < 20 ? 3 : 1;
  var newnbits = $this.a2t_1 + inc | 0;
  var new_0 = IntIntMap.l2t(newnbits, $this.b2t_1, true);
  var inductionVariable = 0;
  var last = $this.h2t_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.h2t_1[n];
      if (!(k === 0)) {
        new_0.m2t(k, $this.i2t_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.a2t_1 = new_0.a2t_1;
  $this.c2t_1 = new_0.c2t_1;
  $this.f2t_1 = new_0.f2t_1;
  $this.g2t_1 = new_0.g2t_1;
  $this.h2t_1 = new_0.h2t_1;
  $this.i2t_1 = new_0.i2t_1;
  $this.j2t_1 = new_0.j2t_1;
}
function growStash_0($this) {
  $this.g2t_1 = imul($this.g2t_1, 2);
  $this.h2t_1 = copyOf_0($this.h2t_1, $this.q2s());
  $this.i2t_1 = copyOf_0($this.i2t_1, $this.q2s());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.d2t_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.h2t_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.h2t_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.h2t_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.h2t_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.h2t_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.h2t_1[index] === 0))
    throw IllegalStateException.y5();
  $this.h2t_1[index] = key;
  $this.i2t_1[index] = value;
  $this.k2t_1 = $this.k2t_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.f2t_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.f2t_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.f2t_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.v2s(numberToInt(_this__u8e3s4.f1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.q1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.r1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.s1();
    out.p2s(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.v2s();
  var _iterator__ex2g4s = _this__u8e3s4.b1();
  while (_iterator__ex2g4s.c1()) {
    var it = _iterator__ex2g4s.d1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.p2s(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.k2u_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.l2u_1(it);
  };
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.u2u_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.u2u_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.v2u_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.v2u_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.u2u_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.u2u_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.u2u_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.w2u_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.w2u_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.f2v(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.q10() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).f1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).p3(_get_items__fzd5gv($this).f1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).k3();
}
function TGenStack__contains_impl_l8kli6($this, element) {
  return _get_items__fzd5gv($this).x2(element);
}
function TGenStack__contains_impl_l8kli6_0($this, element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return TGenStack__contains_impl_l8kli6($this.j2v_1, (element == null ? true : !(element == null)) ? element : THROW_CCE());
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).y2(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.j2v_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).b1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.j2v_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.oc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.nl();
    var value = _destruct__k2r9zo.ol();
    // Inline function 'kotlin.collections.set' call
    this_0.h3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.f1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.sz(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.e1(umod(index, _this__u8e3s4.f1()));
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.oc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    var key = _destruct__k2r9zo.nl();
    var value = _destruct__k2r9zo.ol();
    // Inline function 'kotlin.collections.set' call
    this_0.h3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.b2_1;
  var last = progression.c2_1;
  var step_0 = progression.d2_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.b2_1;
    var last_0 = progression_0.c2_1;
    var step_1 = progression_0.d2_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.v2p(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.y2p(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.v2p(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.v2p(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.y2p(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).w2v(p0).w2v(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).w2v(p0).w2v(p1).w2v(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).w2v(p0).w2v(p1).w2v(p2).w2v(p3);
}
function checkDimensions($this, dim) {
  if (!(dim === $this.c2w_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.c2w_1;
    throw IllegalStateException.h5(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return function ($this$appendGenericArray, it) {
    var v = this$0.m2c($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains_1(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).m2c = get;
protoOf(IntArray2).j2m = set;
protoOf(IntArray2).sz = getAt_0;
protoOf(IntArray2).k2m = getAt;
protoOf(IntArray2).l2m = inside;
protoOf(IntArray2).i2m = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).m2c = get_0;
protoOf(FloatArray2).q2m = set_0;
protoOf(FloatArray2).sz = getAt_1;
protoOf(FloatArray2).k2m = getAt;
protoOf(FloatArray2).l2m = inside;
protoOf(FloatArray2).i2m = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForClass(ByteArrayDeque, 'ByteArrayDeque', ByteArrayDeque);
initMetadataForClass(ShortArrayDeque, 'ShortArrayDeque', ShortArrayDeque);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.b2o, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.m2o, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).a3 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.g2p, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.h2q, VOID, [MutableIterable, Collection]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.a2r, VOID, [MutableIterable, Collection]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.l2r);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.v2s);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.n2t);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [MutableIterable, Collection]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForClass(ByteRingBuffer, 'ByteRingBuffer');
initMetadataForClass(RingBuffer, 'RingBuffer');
initMetadataForClass(ShortRingBuffer, 'ShortRingBuffer');
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).u2v = clone$default;
protoOf(PointArrayList).o2c = get_dimensions;
protoOf(PointArrayList).h1 = isEmpty;
protoOf(PointArrayList).n2v = getComponentList;
protoOf(PointArrayList).o2v = getComponentList$default;
protoOf(PointArrayList).l2q = get_first;
protoOf(PointArrayList).m2q = get_last;
protoOf(PointArrayList).g2c = contains;
protoOf(PointArrayList).j2i = contains_0;
protoOf(PointArrayList).l2c = isNotEmpty;
protoOf(PointArrayList).n2c = isAlmostEquals;
protoOf(PointArrayList).dz = isAlmostEquals$default;
protoOf(PointArrayList).e2c = containsAll;
protoOf(PointArrayList).c2c = indexOf;
protoOf(PointArrayList).b1 = iterator;
protoOf(PointArrayList).a3 = listIterator_0;
protoOf(PointArrayList).b3 = listIterator_1;
protoOf(PointArrayList).c3 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
protoOf(DoubleVectorArrayList).n2c = isAlmostEquals;
protoOf(DoubleVectorArrayList).dz = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_0 as Companion_instance3ldriv9x4zcjm,
  Companion_instance as Companion_instancelqpzd9anuk16,
  Companion_instance_8 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ByteArrayDeque as ByteArrayDeque2dezgzzyyl6zm,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  ShortArrayDeque as ShortArrayDeque13dn2tr6asm80,
  SortOps as SortOps3rp25tm4jbjru,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains_1 as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
